{
  "pull": "Pociągnij, aby odświeżyć...",
  "release": "Puść, aby odświeżyć...",
  "labelRows": "wierszy",
  "tableRowsDisplayed": "{from}-{to} z {count}",
  "tableFirstPage": "Pierwsza strona",
  "tableLastPage": "Ostatnia strona",
  "tableNextPage": "Następna strona",
  "tablePreviousPage": "Poprzednia strona",
  "tableSearchTooltip": "Szukaj",
  "tableSearchPlaceholder": "Szukaj",
  "tableSearchAriaLabel": "Szukaj",
  "tableSearch": "Szukaj...",
  "tableClearSearchAriaLabel": "Wyczyść wyszukiwanie",
  "tableRowsPerPage": "Wierszy na stronę:",
  "sortBy": "SORTUJ WG",
  "showFiltersAndSorting": "Pokaż filtry i sortowanie",
  "hideFiltersAndSorting": "Ukryj filtry i sortowanie",
  "searchPlaceholder": "Szukaj po {{searchKeys}}",
  "all": "Wszystkie",
  "noRecords": "Brak rekordów do wyświetlenia",
  "listTable": {
    "filters": "Filtry",
    "columns": "Kolumny",
    "drawers": {
      "columns": {
        "title": "Kolumny",
        "columns": {
          "show": "Pokaż",
          "columnName": "Nazwa kolumny"
        }
      },
      "filters": {
        "title": "Filtry"
      },
      "buttons": {
        "cancel": "Zamknij",
        "restoreDefaults": "Przywróć domyślne",
        "apply": "Zastosuj"
      }
    }
  }
}
